module.exports = __webpack_public_path__ + "img/card.6c8631d2.svg";